import Vue from 'vue'
import Router from 'vue-router'
import { constantRouterMap } from '@/config/router.config'

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

Vue.use(Router)

export default new Router({
  mode: 'hash',  // 如果需要hash模式则改为'hash'
  base: '/adminweb/',  // 设置路由基础路径
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})